import React from 'react';
import { reduxForm } from 'redux-form';

import FormError from '../../../FormError';
import Json from 'components/Json';

let UpdateStatusModalForm = ({ handleSubmit, response, error }) => {
  return (
    <div>
      <form onSubmit={handleSubmit}>
        {response && (
          <React.Fragment>
            <br />
            <p>
              <b>Result:</b>
            </p>
            <Json data={response} />
          </React.Fragment>
        )}
        {error && <FormError error={error} />}
        <br />
        <button className="btn btn-primary">Update Status</button>
      </form>
    </div>
  );
};

UpdateStatusModalForm = reduxForm({
  form: 'updateStatus',
})(UpdateStatusModalForm);

export default UpdateStatusModalForm;
